/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { RadioGroup } from "@headlessui/react";
import Radio from "components/lib/Shared/Radio";
import Tabs from "components/lib/Shared/Tabs";
import { Form, Formik } from "formik";
import { useContext, useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";

import BeneficialOwnership from "components/PLCTABS/ApplicationReviewTab/BeneficialOwnership";
import ManualTransactionEditContext from "context/ManualTransactionEditContext";
import { getYear } from "date-fns";
import { useRef } from "react";
import { setBatchNumber } from "state/slices/batchNumber";
import { getAllInitiateTransactionChangeAsync } from "state/slices/initiateTransactionChange";
import {
  setActivePeriodTab,
  setARDPeriod,
  setHistoryTransactions,
} from "state/slices/transferYourBusiness";
import CompanySummary from "../BusinessDetails/CompanySummary";
import RegisteredAddress from "../BusinessDetails/RegisteredAddress";
import ShareInformation from "../BusinessDetails/ShareInformation";
import StakeholderDetails from "../BusinessDetails/StakeholderDetails";
import HistoryUpdate from "./HistoryUpdate";

const UpdateHistory = () => {
  const { company, getCompanyStatus, breadCrumbs } = useSelector(
    (state) => state.companyDashboardSlice
  );

  const {
    isUpdateHistory,
    dateTo: To,
    dateFrom: From,
    historyTransactions,
    period: currentTabPeriod,
    activePeriodTab,
  } = useSelector((state) => state.transferYourBusinessSlice);
  const {
    transactionToEdit,
    setRefechTransactionOnEditContext,
    isInManualTransactionEditContext,
    setTransactionToEdit,
  } = useContext(ManualTransactionEditContext);

  const { initiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );

  const [activeYearIndex, setActiveYearIndex] = useState(0);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [makeChanges, setMakeChanges] = useState(true);

  const [transactions, setTransactions] = useState([]);
  const [checkedTabs, setCheckedTabs] = useState([]);
  const [selectionsMade, setSelectionsMade] = useState({});
  const [groupedTransactionsTabIndex, setGroupedTransactionsTabIndex] =
    useState(-1);
  const [isHistoryTransactionTab, setIsHistoryTransactionTab] = useState(false);
  const [addOtherChanges, setAddOtherChanges] = useState(false);

  const [disableForm, setDisableForm] = useState(false);

  const hasUserInteractedWithTransactionTabs = useRef(false);

  const dispatch = useDispatch();

  const generateYearTabs = () => {
    if (!company?.registrationDate) return [];

    const registrationDate = new Date(company.registrationDate);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const registrationYear = registrationDate.getFullYear();
    const isJan1Registration =
      registrationDate.getMonth() === 0 && registrationDate.getDate() === 1;
    const tabs = [];

    // Determine the start date for the Current tab
    let currentStartYear = currentYear;
    const anniversaryThisYear = isJan1Registration
      ? new Date(currentYear, 0, 1)
      : new Date(
          currentYear,
          registrationDate.getMonth(),
          registrationDate.getDate()
        );

    // If the anniversary this year is after the current date, use the previous year's anniversary
    if (anniversaryThisYear > currentDate) {
      currentStartYear = currentYear - 1;
    }

    const currentStartDate = isJan1Registration
      ? new Date(currentStartYear, 0, 1)
      : new Date(
          currentStartYear,
          registrationDate.getMonth(),
          registrationDate.getDate()
        );

    tabs.unshift({
      id: "current",
      label: "Current",
      startDate: currentStartDate,
      endDate: currentDate,
    });

    // Generate tabs for completed return periods in descending order
    for (let year = currentYear - 1; year >= registrationYear; year--) {
      const startDate = isJan1Registration
        ? new Date(year, 0, 1) // January 1
        : new Date(
            year,
            registrationDate.getMonth(),
            registrationDate.getDate()
          );
      const endDate = isJan1Registration
        ? new Date(year, 11, 31) // December 31
        : new Date(
            year + 1,
            registrationDate.getMonth(),
            registrationDate.getDate() - 1
          );
      if (currentDate >= endDate) {
        tabs.push({
          id: isJan1Registration ? `${year}` : `${year + 1}/${year}`,
          label: isJan1Registration ? `${year}` : `${year + 1}/${year}`,
          startDate,
          endDate,
        });
      }
    }

    return tabs;
  };

  const yearTabs = useMemo(
    () => generateYearTabs(),
    [company?.registrationDate, company?.history]
  );

  const nestedTabs = useMemo(() => {
    return [
      { id: "companySummary", label: "Summary" },
      { id: "registeredAddress", label: "Registered Address" },
      { id: "shareInformation", label: "Share Information" },
      { id: "stakeholderDetails", label: "Stakeholder Details" },
      { id: "beneficialOwnership", label: "Beneficial Ownership" },
    ].filter(Boolean);
  }, []);

  //Disable the whole form for a particular ARD if a particular ARD is completed
  useEffect(() => {
    const completedARDs =
      company?.completedHistoryPeriods.map((p) => p.period) ?? [];

    if (completedARDs.includes(currentTabPeriod)) {
      setDisableForm(true);
    } else {
      setDisableForm(false);
    }
  }, [currentTabPeriod, dateFrom, dateTo, To, From]);

  useEffect(async () => {
    const result = await dispatch(
      getAllInitiateTransactionChangeAsync({
        companyId: company?._id,
        params: {
          limit: null,
          skip: 0,
          search: "",
          sort: "updatedAt",
          order: "desc",
        },
      })
    );
  }, [currentTabPeriod, dateFrom, dateTo]);

  useEffect(() => {
    if (activePeriodTab !== null && activePeriodTab !== undefined) {
      setActiveYearIndex(activePeriodTab);
    }
  }, [activePeriodTab]);

  useEffect(() => {
    if (yearTabs.length > 0 && activeYearIndex === null) {
      // setActiveYearIndex(0);
      setSelectedTabIndex(0);
      setSelectedTab(nestedTabs[0]);
      const { startDate, endDate } = yearTabs[0];
      setDateFrom(startDate);
      setDateTo(endDate);
    }
  }, [yearTabs, nestedTabs, activeYearIndex]);

  useEffect(() => {
    if (activeYearIndex !== null && yearTabs[activeYearIndex]) {
      const { startDate, endDate } = yearTabs[activeYearIndex];
      setDateFrom(startDate);
      setDateTo(endDate);
    }
  }, [activeYearIndex, yearTabs]);

  useEffect(() => {
    const tempSelectedTab = nestedTabs[selectedTabIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [nestedTabs, selectedTabIndex]);

  useEffect(() => {
    const filtered = initiatedTransactions?.items?.filter((transaction) => {
      const transactionPeriod = transaction?.period;

      if (!transactionPeriod || !currentTabPeriod) return false;

      return (
        transactionPeriod === currentTabPeriod && transaction?.isForHistory
      );
    });

    dispatch(setHistoryTransactions(filtered));
  }, [initiatedTransactions?.items, currentTabPeriod]);

  //Group transactions by batch number or trxRef
  const groupedHistoryTransactions = useMemo(() => {
    const groups = {};

    historyTransactions?.forEach((transaction) => {
      const batchNo = transaction?.batchNo;
      const trxRef = transaction?.trxRef;

      let groupKey;

      if (batchNo && batchNo.trim() !== "") {
        groupKey = batchNo;
      } else if (trxRef && trxRef.trim() !== "") {
        groupKey = trxRef;
      } else {
        groupKey = "ungrouped-unknown";
      }

      if (!groups[groupKey]) {
        groups[groupKey] = [];
      }

      groups[groupKey].push(transaction);
    });
    return groups;
  }, [historyTransactions, currentTabPeriod]);

  ///generate tabs for the grouped transactions
  const transactionGroupedTabs = useMemo(() => {
    return [
      ...Object.keys(groupedHistoryTransactions).map((key) => {
        const transactions = groupedHistoryTransactions[key];
        const firstTransaction = transactions[0];
        const label = firstTransaction?.batchNo
          ? `Batch ${firstTransaction.batchNo}`
          : `Ref ${firstTransaction.trxRef}`;

        return {
          id: key,
          label,
          transactions,
        };
      }),
      {
        id: "newChange",
        label: "New Change",
        transactions: [],
      },
    ];
  }, [groupedHistoryTransactions]);

  useEffect(() => {
    //Select the transaction tab based on transactionToEdit from manual edit context
    if (
      transactionToEdit &&
      historyTransactions.length > 0 &&
      !addOtherChanges &&
      !hasUserInteractedWithTransactionTabs.current
    ) {
      const targetTabIndex = transactionGroupedTabs.findIndex((tab) => {
        return tab.transactions.some(
          (trx) => trx._id === transactionToEdit._id
        );
      });

      if (targetTabIndex !== -1) {
        setGroupedTransactionsTabIndex(targetTabIndex);
        setIsHistoryTransactionTab(true);
        //hasUserInteractedWithTransactionTabs.current = true;
      }
    } else if (
      (!transactionToEdit || addOtherChanges) &&
      transactionGroupedTabs.length > 0
    ) {
      //If user has clicked on add other changes button, then select the "New Change" tab
      const newChangeTabIndex = transactionGroupedTabs.findIndex(
        (tab) => tab.id === "newChange"
      );
      if (newChangeTabIndex !== -1) {
        setGroupedTransactionsTabIndex(newChangeTabIndex);
        setIsHistoryTransactionTab(true);
        //hasUserInteractedWithTransactionTabs.current = true;
      }
    }
  }, [transactionGroupedTabs, addOtherChanges]);
  const handleTabChange = (index) => {
    //if already selection has been made, do not change the tab
    if (groupedTransactionsTabIndex === index) return;
    setGroupedTransactionsTabIndex(index);
    hasUserInteractedWithTransactionTabs.current = true;
    setIsHistoryTransactionTab(true);

    const selectedTab = transactionGroupedTabs[index];
    if (selectedTab) {
      if (selectedTab.id === "newChange") {
        setSelectionsMade({});
        setCheckedTabs([]);
        setTransactions([]);
      } else {
        setAddOtherChanges(false);
        setSelectionsMade({});
        setCheckedTabs([]);
        setTransactions(selectedTab.transactions || []);
        dispatch(setBatchNumber(selectedTab?.transactions[0]?.batchNo || null));
      }
    }
  };

  const renderDate = () => {
    if (activeYearIndex === null) return <div>Loading...</div>;
    if (!company || !company._id) return <div>No company data available</div>;

    const companyId = company._id;
    const { startDate, endDate } = yearTabs[activeYearIndex];
    return (
      <div>
        <div className="flex items-center gap-4 my-6 w-[80%]">
          <h2 className="text-lg">Period:</h2>
          <div className="flex flex-row items-center gap-2">
            <label className="text-primary text-sm">From</label>
            <DatePicker
              selected={dateFrom}
              onChange={(date) => setDateFrom(date)}
              dateFormat="dd/MM/yyyy"
              minDate={startDate}
              maxDate={endDate}
              placeholderText="Select start date"
              className="block w-full px-1 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
              disabled
            />
          </div>
          <div className="flex flex-row items-center gap-2">
            <label className="text-primary text-sm ">To </label>
            <DatePicker
              selected={dateTo}
              onChange={(date) => setDateTo(date)}
              dateFormat="dd/MM/yyyy"
              minDate={startDate}
              maxDate={endDate}
              placeholderText="Select end date"
              className="block w-full px-1 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
              disabled
            />
          </div>
        </div>
      </div>
    );
  };

  const initialValues = {
    selectedOption: "yesChanges",
  };
  const handleChange = (value) => {
    if (value === "yesChanges") {
      setMakeChanges(true);
    } else {
      setMakeChanges(false);
    }
  };
  //set the global active period to be used for all history transactions as one of the transaction property to track the transactions of specific period and only for history update module

  useEffect(() => {
    const currentYearTab = yearTabs[activeYearIndex];
    const tabPeriod = `${getYear(new Date(dateTo))}/${getYear(
      new Date(dateFrom)
    )}`;

    if (currentYearTab) {
      dispatch(
        setARDPeriod({
          period: tabPeriod,
          dateFrom: currentYearTab.startDate,
          dateTo: currentYearTab.endDate,
        })
      );
    }
  }, [activeYearIndex, dateFrom, dateTo]);

  useEffect(() => {
    const trxPeriod = transactionToEdit?.period;
    if (!trxPeriod) return;
    const foundTabIndex = yearTabs.findIndex(
      (year) =>
        `${getYear(new Date(year?.endDate))}/${getYear(
          new Date(year?.startDate)
        )}` === trxPeriod
    );
    dispatch(
      setARDPeriod({
        period: trxPeriod,
        dateFrom: yearTabs[foundTabIndex].startDate,
        dateTo: yearTabs[foundTabIndex].endDate,
      })
    );
    dispatch(setActivePeriodTab(foundTabIndex));
  }, [transactionToEdit, dateFrom, dateTo]);

  return (
    <div>
      <h2 className="text-lg font-medium mb-4">Company History</h2>
      <p className="text-sm text-sflPrimary mb-6">
        Update the history of your company, including changes to its registered
        address, share information, and beneficial ownership.
      </p>
      {yearTabs.length > 0 ? (
        <>
          <Tabs
            tabs={yearTabs}
            selectedTabIndex={activeYearIndex}
            showTooltip
            historyTabsClassName={(tab, index) =>
              `py-2 px-1 text-sm font-medium cursor-pointer text-ellipsis overflow-hidden relative ${
                index === activeYearIndex
                  ? "bg-white text-gray-300"
                  : "text-gray-500"
              }`
            }
          />
          <div className="flex items-center justify-between bg-white mt-4 px-4 rounded-md">
            {renderDate()}
            <Formik
              enableReinitialize
              initialValues={initialValues}
              onSubmit={(values) => {}}
            >
              {({ values, errors, touched, setFieldValue }) => {
                return (
                  <Form>
                    <fieldset disabled={historyTransactions?.length > 0}>
                      <RadioGroup
                        className="flex items-center justify-center gap-4"
                        value={values?.selectedOption}
                        onChange={(value) => {
                          handleChange(value);
                        }}
                      >
                        <RadioGroup.Label className="text-base">
                          <div>
                            <p className="text-sm text-nowrap mr-4">
                              Were there any changes recorded in this period?
                            </p>
                          </div>
                        </RadioGroup.Label>
                        <RadioGroup.Option value="yesChanges">
                          <Radio
                            name="selectedOption"
                            id="selectedOption"
                            label="Yes"
                            value="yesChanges"
                          />
                        </RadioGroup.Option>
                        <RadioGroup.Option value="noChanges">
                          <Radio
                            name="selectedOption"
                            id="selectedOption"
                            label="No"
                            value="noChanges"
                          />
                        </RadioGroup.Option>
                      </RadioGroup>
                    </fieldset>
                  </Form>
                );
              }}
            </Formik>
          </div>
          {historyTransactions?.length > 0 && (
            <div>
              <hr className="my-4 border-b-1 border-yellow-900" />

              <div className="my-4">
                {/* Each period independent transaction(s) tabs */}
                <p className="text-sm font-bold bg-amber-[1/2] rounded-md inline-block px-2 py-1">
                  Make sure changes in each transaction tab(s) are correctly
                  completed before proceeding to the next ARD
                </p>
                <Tabs
                  tabs={transactionGroupedTabs}
                  selectedTabIndex={groupedTransactionsTabIndex}
                  setSelectedTabIndex={handleTabChange}
                  showTooltip
                />
              </div>
            </div>
          )}

          {makeChanges ? (
            <div>
              <HistoryUpdate
                dateFrom={dateFrom}
                dateTo={dateTo}
                setActiveYearIndex={setActiveYearIndex}
                activeYearIndex={activeYearIndex}
                checkedTabs={checkedTabs}
                setCheckedTabs={setCheckedTabs}
                selectionsMade={selectionsMade}
                setSelectionsMade={setSelectionsMade}
                transactions={transactions}
                setTransactions={setTransactions}
                isHistoryTransactionTab={isHistoryTransactionTab}
                setAddOtherChanges={setAddOtherChanges}
                disableForm={disableForm}
                yearTabs={yearTabs}
              />
            </div>
          ) : (
            <div>
              <Tabs
                tabs={nestedTabs}
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={setSelectedTabIndex}
                showTooltip
              />
              {selectedTab?.id === "companySummary" && <CompanySummary />}
              {selectedTab?.id === "registeredAddress" && <RegisteredAddress />}
              {selectedTab?.id === "shareInformation" && <ShareInformation />}
              {selectedTab?.id === "stakeholderDetails" && (
                <StakeholderDetails />
              )}
              {selectedTab?.id === "beneficialOwnership" && (
                <BeneficialOwnership />
              )}
            </div>
          )}
        </>
      ) : (
        <div>No return periods available yet</div>
      )}
    </div>
  );
};

export default UpdateHistory;
